var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchRoundBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#FAFAFC",
    stroke: "#EFF0FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.2h7.905c.04 0 .062-.045.04-.077l-1.4-1.923M12 9.2H4.11a.048.048 0 00-.036.08l1.744 1.92",
    stroke: "#2C2842",
    strokeLinecap: "square"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgcng9IjcuNSIgZmlsbD0iI0ZBRkFGQyIgc3Ryb2tlPSIjRUZGMEZBIi8+CjxwYXRoIGQ9Ik00IDYuMTk5OTVIMTEuOTA1QzExLjk0NDUgNi4xOTk5NSAxMS45Njc0IDYuMTU1MDkgMTEuOTQ0MSA2LjEyMzExTDEwLjU0NTUgNC4xOTk5NSIgc3Ryb2tlPSIjMkMyODQyIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+CjxwYXRoIGQ9Ik0xMiA5LjE5OTk1TDQuMTA5MzcgOS4xOTk5NUM0LjA2NzM3IDkuMTk5OTUgNC4wNDUzMiA5LjI0OTggNC4wNzM1NyA5LjI4MDg4TDUuODE4MTggMTEuMiIgc3Ryb2tlPSIjMkMyODQyIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+Cjwvc3ZnPgo=";
export { SvgSwitchRoundBlack as ReactComponent };